import React from "react";
import './TopPafeInfo.css';
import IndexMain02 from "../../../../img/IndexMain/moneta300.png";
import IndexMain03 from "../../../../img/IndexMain/IndexMain03.svg";
import IndexMain04 from "../../../../img/IndexMain/IndexMain04.svg";
import IndexMain05 from "../../../../img/IndexMain/IndexMain05.svg";
import bitcoin from "../../../../img/IndexMain/bitcoin.png";
import {withRouter} from "react-router-dom";
import {withAuth} from "../../../withAuth";
import Query from "react-apollo/Query";
import { GET_USER_STEAKING_COINS } from "../../../../queries";
import { headLang } from "./headLang";

class TopPafeInfo extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            del : '',
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        };
    }

    render(){
        return (
            <div className="TopPafeInfo">
                <div className="TopPafeInfoElement">
                    <div className="TopPafeInfoElementIn">
                        <div className="TopPafeInfoElementImg"><img width="35px" src={IndexMain02}/></div>
                        <div className="TopPafeInfoElementText">$ARTY</div>
                        <div className="TopPafeInfoElementMoney">{this.props.session.Balance.toFixed(3)}</div>
                    </div>
                </div>    
                <Query query = {GET_USER_STEAKING_COINS} variables={{ email: this.props.session.email }}>
                    {({ data, loading, error}) => {
                        if (loading) return <div>loading</div>;
                        if (error) {
                            window.open(`${process.env.SITE_ADDRESS}/noauth/`, '_top'); 
                            return <div>error</div>;
                        }

                        return (
                            <div className="TopPafeInfoElement" style={{'margin-left': '15px'}}>
                                <div className="TopPafeInfoElementIn">
                                    <div className="TopPafeInfoElementImg"><img width="35px" src={IndexMain02}/></div>
                                    <div className="TopPafeInfoElementText">{headLang.staking[this.state.Language]}</div>
                                    <div className="TopPafeInfoElementMoney">{data.getUserSteakingCoins.steakingCoins.toFixed(3)}</div>
                                </div>
                            </div>
                        )
                    }}
                </Query>
            </div>        
        )}}

export default withAuth(session => session && session)(withRouter(TopPafeInfo));